import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import parse from 'html-react-parser';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';

import { Editor } from '@tinymce/tinymce-react';
import { useRef } from 'react';
import FileInput from '../Common-Components/FileInput';


const TeacherReplyModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const [question, setQuestion] = useState('');
    const editorRef = useRef(null);
    let initialData = {
        sn: 0,
        firstName: '',
        lastName: '',
        sort: 0,
        teacherReply: '',
        file: '',
        ctype: 'question',
        userCode: ""
    }

    const [replyData, setReplyData] = useState(initialData);
    const [isFileUploading, setIsFileUploading] = useState(false);


    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            console.log(item)
            if (item.sn > 0) {
                setReplyData({
                    sn: item.sn, teacherReply: item.teacherReply, file: item.teacherFile || '', firstName: item.firstName, lastName: item.lastName, ctype: item.ctype || 'question', userCode: item.userCode, facultyName: userDetails?.FirstName
                })
                setQuestion(item.commentTitle);
            }
            setModalBox(true);
        }
    }));

    const handleSaveCourseType = (value) => {
        // if (replyData.teacherReply.trim().length === 0) {
        //     toast.error("Input Field can not be Blank")
        // }
        console.log(replyData)

        axios.post(BACKEND_SERVER_URL + '/saveTeacherReply', replyData).then((response) => {
            if (response.data.statusCode === 201) {
                toast.success(response.data.message)
                props.setTeacherCommentsLoading(!props.loadTeacherComments);
                setReplyData(initialData)
                setModalBox(false);
            }
        }).catch(error => {
            console.log(error)
            toast.error(error.response.data.message)
        })
    }
    useEffect(() => {
        if (!modalBox) {
            setReplyData(initialData); // Reset form data when modal is closed 
        }
    }, [modalBox]);

    const handleChange = (name, value) => {
        setReplyData((preData) => (
            { ...preData, [name]: value }
        ));
    };

    //tinymce editor focusin event handler
    // This is to prevent the focusin event from propagating to the document level when the editor is focused.
    useEffect(() => {
        if (editorRef.current) {
            const focusinHandler = (e) => {
                if (e.target instanceof Element && e.target.closest(".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
                    e.stopImmediatePropagation();
                }
            };

            document.addEventListener('focusin', focusinHandler);

            return () => {
                document.removeEventListener('focusin', focusinHandler);
            };
        }
    }, [editorRef]);

    const editorConfig = {
        height: 300,
        menubar: true,
        plugins: [
            'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'help', 'wordcount',
            'emoticons', 'hr', 'pagebreak', 'nonbreaking', 'directionality'
        ],
        toolbar:
            'undo redo | blocks fontfamily fontsize | ' +
            'bold italic underline strikethrough forecolor backcolor | ' +
            'alignleft aligncenter alignright alignjustify | ' +
            'bullist numlist outdent indent | link media emoticons | ' +
            'hr pagebreak | table | removeformat code fullscreen | help',
        font_family_formats:
            'Arial=arial,helvetica,sans-serif;Courier New=courier new,courier;Times New Roman=times new roman,times;Verdana=verdana,geneva;',
        fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        setup: (editor) => {
            editor.on('keydown', (e) => {
                if (e.key === 'Enter') {
                    editor.execCommand('InsertLineBreak');
                    e.preventDefault();
                }
            });
        }
    };

    return (
        <>
            <Modal onHide={setModalBox} show={modalBox} backdrop="static" dialogClassName="custom-modal-width"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> Teacher Reply {replyData.firstName ? `- ${replyData.firstName} ${replyData.lastName && replyData.lastName !== 'null' ? replyData.lastName : ''}` : ''}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body pt-2 ">
                        <div className="">
                            <label htmlFor="inputAcademicYear1" className="form-label text-primary">Student Question</label>
                            <div className="card-body ms-0 ps-0 pt-0 teacher_support_query ps-3 bg-light">
                                {
                                    parse(question)
                                }
                            </div>
                        </div>                     
                    </div>
                    <div className="modal-body pt-0 mt-0">
                        <div className="">
                            <label htmlFor="inputAcademicYear" className="form-label text-primary">Teacher Reply {replyData.firstName ? `- ${replyData.firstName} ${replyData.lastName && replyData.lastName !== 'null' ? replyData.lastName : ''}` : ''}</label>
                            <div className="card-body custom-ekeditor ms-0 ps-0 pt-0">
                                <Editor
                                    tinymceScriptSrc="/tinymce/tinymce.min.js"
                                    onInit={(_evt, editor) => (editorRef.current = editor)}
                                    value={replyData.teacherReply || ''}
                                    init={{
                                        ...editorConfig,
                                        content_style: `
                                                            body {
                                                                font-family: 'Roboto', 'Segoe UI', sans-serif;
                                                                font-size: 15px;
                                                                padding: 2px;
                                                                background-color: #ffffff;
                                                                color: #212529;
                                                            }
                                                            `,
                                        base_url: '/tinymce',
                                    }}
                                    onEditorChange={(content) => handleChange('teacherReply', content)}
                                />
                                {/* <CKEditor
                                    config={{
                                        extraPlugins: [uploadPlugin],
                                    }}
                                    editor={Editor}
                                    // data="<p>Hello from CKEditor 5!</p>"
                                    onReady={editor => {
                                        // You can store the "editor" and use when it is needed.
                                    }}
                                    data={replyData.teacherReply ?? ''}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        console.log('data', data)
                                        handleChange('teacherReply', data)

                                    }}
                                    onBlur={(event, editor) => {
                                    }}
                                    onFocus={(event, editor) => {
                                        //console.log( 'Focus.', editor );
                                    }}

                                /> */}
                            </div>

                        </div>
                        <div className="">
                            <FileInput isMandatory={false} handleChangeCallBack={handleChange} labelName="Upload Answer" inputType="text" uploadedFileURL={replyData?.file} inputName='file' accept=".pdf,.png,.jpg" onUploadStateChange={setIsFileUploading} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " disabled={isFileUploading} onClick={handleSaveCourseType}>
                            {isFileUploading ? "Uploading..." : "Reply"}
                        </button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default TeacherReplyModal;